import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useTreeReferencesContext } from '../../../../../../tree/references/TreeReferencesContext.tsx';
import { ExpressionReferenceInput } from '../../../../../expressions/references/input/ExpressionReferenceInput.tsx';
import { WidgetType } from '../../../../Widget.ts';

export interface IRepeatableListSelectInputProps {}

/**
 * Permette di selezionare la reference a un widget lista ripetibile.
 */
export function RepeatableListSelectInput(
  props: IRepeatableListSelectInputProps,
) {
  const { references } = useTreeReferencesContext();

  return (
    <FormItem
      name="listReference"
      label="Riferimento lista ripetibile"
      help="Indicare la lista ripetibile collegata al widget di controllo"
    >
      <ExpressionReferenceInput
        width="100%"
        size="large"
        name={`listReference`}
        references={references.filter(
          r => r.widgetType === WidgetType.Repeatable,
        )}
      />
    </FormItem>
  );
}
